import { Locale } from '../enums/locale.enum';
import { Direction } from '../enums/direction.enum';
export interface ILanguage {
  id: string;
  name: string;
  direction: Direction;
  shortname: Locale;
  text: string;
}
